<template>
  <div class="wrapper">
    <!-- <van-search
      v-model="value"
      shape="round"
      background="#F8F8F8"
      placeholder="搜索挂号科室"
      @input="handleQuery"
    >
      <template v-slot:left-icon>
        <img src="@/assets/payment/sousuo_icon.png" class="ss_icon">
      </template>
    </van-search> -->
    <lastpage></lastpage>
    <div class="cate_content" v-if="showIf">
      <ul class="list_index">
        <li
          v-for="(item, index) in oneList"
          :key="item.DeptID"
          @click="handleTab(index, item.DeptID)"
          :class="{ list_xuan: current === index }"
        >
          <span>{{ item.DeptName }}</span>
          <!-- <svg :class="current == index?`selectTriangle`:`hide`" width="14" height="14" viewBox="-50 -50 300 300">
            <polygon class="triangle" stroke-linejoin="round" points="200 100 0 200 0 0"/>
          </svg> -->
        </li>
      </ul>
      <ul class="list_content">
        <li
          v-for="(item, index) in list"
          :key="item.DeptID"
          @click="choice(item)"
        >
          <span>{{ item.DeptName }}</span>
          <span class="icon_cl"><van-icon name="arrow"/></span>
        </li>
      </ul>
    </div>
    <div class="query_content" v-if="!showIf">
      <van-empty description="该院区暂无可预约的科室" />
    </div>
  </div>
</template>

<script>
import { getRegDate, getRegLocation, getRefRecord } from "@/request/api.js";
import lastpage from "@/components/lastpage/lastpage.vue";
import { Dialog, Toast } from "vant";

const USER_ID = "7148";

function apiObj(res) {
  return ((res || {}).data || {}).obj || {};
}

export default {
  components: {
    lastpage
  },
  data() {
    return {
      current: 0,
      showIf: true,
      timeString: "",
      deptID: null,
      oneList: [],
      list: [],
      hspCode: sessionStorage.getItem("hspCode"),
      card: JSON.parse(sessionStorage.getItem("card"))
    };
  },
  async created() {
    await this.getTime();
  },
  activated() {
    this.getTime();
  },
  methods: {
    clearAllScheduleData() {
      this.showIf = false;
      this.timeString = "";
      this.oneList = [];
      this.list = [];
      this.deptID = null;
    },
    // 获取可挂号日期
    async getTime() {
      try {
        const res = await getRegDate({
          hspCode: this.hspCode,
          userId: USER_ID
        });
        const resultData = apiObj(res).resultData || [];
        if (resultData.length === 0) {
          this.clearAllScheduleData();
          return;
        }

        this.timeString = resultData
          .map(d => this.$moment(d).format("YYYY-MM-DD"))
          .join(",");
        this.showIf = true;
        await this.getDepartment();
      } catch (e) {
        this.clearAllScheduleData();
      }
    },
    // 科室查询
    async getDepartment() {
      if (!this.timeString) {
        this.clearAllScheduleData();
        return;
      }

      const baseMap = {
        clinicDate: this.timeString,
        hspCode: this.hspCode,
        userId: USER_ID
      };

      if (!this.deptID) {
        const res = await getRegLocation({ ...baseMap, deptID: null });
        const resultData = apiObj(res).resultData || [];
        this.oneList = resultData;

        if (resultData.length === 0) {
          this.showIf = false;
          this.list = [];
          this.deptID = null;
          return;
        }

        this.deptID = resultData[0].DeptID;
        this.current = 0;
      }

      const res2 = await getRegLocation({ ...baseMap, deptID: this.deptID });
      this.list = apiObj(res2).resultData || [];
    },
    handleTab(num, deptid) {
      this.deptID = deptid;
      this.current = num;
      this.getDepartment();
    },
    /** resultData 有实质内容才视为「有数据」（需弹窗） */
    hasRefRecordData(resultData) {
      if (resultData == null) return false;
      if (Array.isArray(resultData)) return resultData.length > 0;
      if (typeof resultData === "object")
        return Object.keys(resultData).length > 0;
      return true;
    },
    goChooseDoctor(item) {
      sessionStorage.setItem("DeptID", item.DeptID);
      this.$router.push("/ChooseDoctor");
    },
    async choice(item) {
      try {
        const data = await getRefRecord({
          isPay: "0",
          patientId: this.card.patientId,
          userId: USER_ID
        });
        const res = apiObj(data);
        sessionStorage.setItem("refRecordData", JSON.stringify(res));

        if (this.hasRefRecordData(res.resultData)) {
          await Dialog.alert({
            message: res.resultMsg || "提示",
            confirmButtonText: "确定"
          });
        }
        this.goChooseDoctor(item);
      } catch (error) {
        Toast.fail(
          error && error.message ? error.message : "请求失败"
        );
      }
    }
  }
};
</script>

<style lang="less" scoped>
.wrapper {
  width: 100%;
  height: 100%;
  display: flex;
  flex-flow: column nowrap;
  background-color: #f8f8f8;
  /deep/ .van-search__content {
    background-color: #e4e4e4;
  }
  .triangle {
    fill: #1c96cb;
    stroke: #1c96cb;
    stroke-width: 100;
  }
  .ss_icon {
    position: relative;
    top: 2px;
    width: 11px;
    height: 13px;
  }
  .cate_content {
    // width: 375px;
    flex-grow: 1;
    display: flex;
    flex-flow: row nowrap;
    position: relative;
    overflow: hidden;
    .list_index {
      display: flex;
      flex-flow: column nowrap;
      overflow-y: scroll;
      width: 118px;
      height: 100%;
      background-color: #f8f8f8;
      border-right: 1px solid rgb(207, 217, 255);
      > li {
        // border-bottom: 1px solid rgb(207, 217, 255);
        position: relative;
        // height: 45px;
        padding: 20px 0px;
        color: black;
        font-size: 15px;
        font-weight: 400;
        text-align: center;
        display: flex;
        flex-flow: row nowrap;
        align-items: center;
        > span {
          // flex: 1;
          width: 100%;
          padding: 0px 14px 0px 12px;
        }
        .selectTriangle {
          position: absolute;
          right: 0px;
          // margin: 1px 6px 0px 0px;
        }
        .hide {
          display: none;
        }
      }
      .list_xuan {
        background: #fff;
        color: #1c96cb;
        font-weight: 700;
      }
    }
    .list_content {
      flex: 1;
      position: relative;
      flex-grow: 1;
      height: 100%;
      background: #fff;
      display: flex;
      flex-flow: column nowrap;
      overflow-y: scroll;
      // margin-right: 10px;
      > li {
        position: relative;
        // height: 45px;
        // line-height: 45px;
        display: flex;
        box-sizing: border-box;
        padding: 12px 30px;
        font-size: 16px;
        font-weight: 700;
        border-bottom: 1px solid rgb(233, 233, 233);
        align-items: center;
        > span:nth-child(1) {
          flex: 1;
        }
        .icon_cl {
          font-size: 16px;
        }
      }
    }
  }
  .query_content {
    margin-top: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Index/DepartmentSelection.vue